import { useContext, useState } from 'react';
import { Grid, AppBar, Tabs, Tab, Typography } from '@material-ui/core';
import { Page } from 'components';
import { ticketContext } from './TicketContext';
import { Details, Messages, Resolutions, Request, Notifications, Activities, UpdateTicketStatus, AssegneeSuggestions } from './components';
import { applicationContext, appUserContext } from 'helpers/services';
import { ReferenceData, UserType } from 'helpers/enums';

let Ticket = () => {
    let { ticketTypes, referenceData } = useContext(applicationContext);
    let { currentUser } = useContext(appUserContext);
    let { isLoading, ticket, statusDialog } = useContext(ticketContext);

    const ticketTabs = {
        messages: "Messages",
        request: "Request",
        notifications: "Notifications",
        activities: "Activities",
        resolutions: "Resolutions"
    };


    let [tab, setTab] = useState(ticketTabs.messages);

    return (

        <Page
            useHeader={true}
            isLoading={isLoading}
            title={ticket.title}
            subtitle={
                <Typography variant="h5">
                    {ticket.ticketNumber}
                    &nbsp;&middot;&nbsp;
                    {ticketTypes.getValueByKey(ticket.ticketTypeId, 'id', 'name')}
                    &nbsp;&middot;&nbsp;
                    {referenceData.getByKey(ReferenceData.Supplier)?.values.getValueByKey(ticket.supplier)}
                </Typography>
            }
        >
            {isLoading === false &&
                <Grid container>
                    <Grid item xs={12} md={4}>
                        <Details />
                        <AssegneeSuggestions />
                    </Grid>
                    <Grid item xs>
                        <AppBar position="static" color="inherit">
                            <Tabs value={tab} onChange={(e, newValue) => setTab(newValue)}>
                                <Tab label={ticketTabs.messages} value={ticketTabs.messages} />
                                <Tab label={ticketTabs.request} value={ticketTabs.request} />
                                {currentUser?.typology === UserType.VitecUser &&
                                    <Tab label={ticketTabs.resolutions} value={ticketTabs.resolutions} />
                                }
                                {currentUser?.typology === UserType.VitecUser &&
                                    <Tab label={ticketTabs.notifications} value={ticketTabs.notifications} />
                                }
                                {currentUser?.typology === UserType.VitecUser &&
                                    <Tab label={ticketTabs.activities} value={ticketTabs.activities} />
                                }
                            </Tabs>
                        </AppBar>
                        <div role="tabpanel" hidden={tab !== ticketTabs.messages}>
                            <Messages ticketId={ticket.id} />
                        </div>
                        <div role="tabpanel" hidden={tab !== ticketTabs.request}>
                            {tab === ticketTabs.request &&
                                <Request typeInfo={ticketTypes.getValueByKey(ticket.ticketTypeId, 'id', 'typeInfo')} />
                            }
                        </div>

                        {currentUser?.typology === UserType.VitecUser &&
                            <>
                                <div role="tabpanel" hidden={tab !== ticketTabs.resolutions}>
                                    <Resolutions
                                        isReadOnly={ticket.hasCustomerServiceAssignee === false || ticket.isReadOnly}
                                        ticketId={ticket.id}
                                    />
                                </div>
                                <div role="tabpanel" hidden={tab !== ticketTabs.notifications}>
                                    <Notifications />
                                </div>
                                <div role="tabpanel" hidden={tab !== ticketTabs.activities}>
                                    <Activities />
                                </div>
                            </>
                        }

                    </Grid>
                </Grid>
            }

            {statusDialog.open && <UpdateTicketStatus />}
        </Page>
    )
}

export default Ticket;